// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/df-and-vdf-assistance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/df-and-vdf-assistance/df-and-vdf-assistance.js';

mount([g0]);
